import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    rumors: [],
    knowledge: [],
    laws: [],
    comments: []
  },
  getters: {
    isAuthenticated: state => !!state.user,
    currentUser: state => state.user,
    getRumorById: state => id => state.rumors.find(rumor => rumor.id === parseInt(id)),
    getKnowledgeById: state => id => state.knowledge.find(item => item.id === parseInt(id)),
    getLawById: state => id => state.laws.find(law => law.id == parseInt(id)),
    getCommentsByRumorId: state => rumorId => state.comments.filter(comment => comment.rumorId === parseInt(rumorId))
  },
  mutations: {
    setUser(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    clearUser(state) {
      state.user = null
      localStorage.removeItem('user')
    },
    updateUser(state, userData) {
      state.user = { ...state.user, ...userData }
      localStorage.setItem('user', JSON.stringify(state.user))
    },
    setRumors(state, rumors) {
      state.rumors = rumors
    },
    setKnowledge(state, knowledge) {
      state.knowledge = knowledge
    },
    setLaws(state, laws) {
      state.laws = laws
    },
    setComments(state, comments) {
      state.comments = comments
    },
    addComment(state, comment) {
      state.comments.push(comment)
    }
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await axios.get('http://localhost:3000/users', {
          params: {
            username: credentials.username,
            password: credentials.password
          }
        })
        
        if (response.data.length > 0) {
          const user = response.data[0]
          delete user.password // 不存储密码
          commit('setUser', user)
          return { success: true }
        } else {
          return { success: false, message: '用户名或密码错误' }
        }
      } catch (error) {
        return { success: false, message: '登录失败，请稍后再试' }
      }
    },
    
    async register({ commit }, userData) {
      try {
        // 检查用户名是否已存在
        const checkUser = await axios.get(`http://localhost:3000/users?username=${userData.username}`)
        
        if (checkUser.data.length > 0) {
          return { success: false, message: '用户名已存在' }
        }
        
        const response = await axios.post('http://localhost:3000/users', userData)
        const user = response.data
        delete user.password // 不存储密码
        commit('setUser', user)
        return { success: true }
      } catch (error) {
        return { success: false, message: '注册失败，请稍后再试' }
      }
    },
    
    logout({ commit }) {
      commit('clearUser')
    },
    
    async updateProfile({ commit }, userData) {
      try {
        const response = await axios.patch(`http://localhost:3000/users/${userData.id}`, userData)
        commit('updateUser', response.data)
        return { success: true }
      } catch (error) {
        return { success: false, message: '更新失败，请稍后再试' }
      }
    },
    
    async fetchRumors({ commit }, { category = null, keyword = null } = {}) {
      try {
        let url = 'http://localhost:3000/rumors'
        const params = {}
        
        if (category) {
          params.category = category
        }
        
        if (keyword) {
          params.q = keyword
        }
        
        const response = await axios.get(url, { params })
        commit('setRumors', response.data)
        return { success: true }
      } catch (error) {
        return { success: false, message: '获取谣言信息失败' }
      }
    },
    
    async fetchKnowledge({ commit }, { category = null, keyword = null } = {}) {
      try {
        let url = 'http://localhost:3000/knowledge'
        const params = {}
        
        if (category) {
          params.category = category
        }
        
        if (keyword) {
          params.q = keyword
        }
        
        const response = await axios.get(url, { params })
        commit('setKnowledge', response.data)
        return { success: true }
      } catch (error) {
        return { success: false, message: '获取科普知识失败' }
      }
    },
    
    async fetchLaws({ commit }, { keyword = null } = {}) {
      try {
        let url = 'http://localhost:3000/laws'
        const params = {}
        if (keyword) {
          params.q = keyword
        }
        const response = await axios.get(url, { params })
        commit('setLaws', response.data)
        return { success: true }
      } catch (error) {
        return { success: false, message: '获取法律政策失败' }
      }
    },
    
    async fetchComments({ commit }, rumorId) {
      try {
        const response = await axios.get(`http://localhost:3000/comments?rumorId=${rumorId}`)
        commit('setComments', response.data)
        return { success: true }
      } catch (error) {
        return { success: false, message: '获取评论失败' }
      }
    },
    
    async addComment({ commit, state }, commentData) {
      try {
        const newComment = {
          ...commentData,
          userId: state.user.id,
          username: state.user.username,
          createdAt: new Date().toISOString()
        }
        
        const response = await axios.post('http://localhost:3000/comments', newComment)
        commit('addComment', response.data)
        return { success: true }
      } catch (error) {
        return { success: false, message: '添加评论失败' }
      }
    }
  }
}) 